
import React from 'react';
import { FilePieChart } from 'lucide-react';

interface ComplianceDetailsProps {
  complianceBefore: number;
  complianceAfter: number;
  complianceImprovement: number;
}

export const ComplianceDetails = ({ 
  complianceBefore, 
  complianceAfter, 
  complianceImprovement 
}: ComplianceDetailsProps) => {
  return (
    <div className="p-4 border-t">
      <h3 className="text-sm font-semibold mb-2 flex items-center">
        <FilePieChart className="h-4 w-4 mr-1 text-primary" />
        Compliance Details
      </h3>
      <div className="bg-muted/30 p-3 rounded-md text-sm">
        <div className="flex flex-col space-y-2">
          <div className="flex justify-between">
            <span className="text-muted-foreground">Before:</span>
            <span className="font-medium">{complianceBefore}%</span>
          </div>
          <div className="flex justify-between">
            <span className="text-muted-foreground">After:</span>
            <span className="font-medium">{complianceAfter}%</span>
          </div>
          <div className="flex justify-between">
            <span className="text-muted-foreground">Improvement:</span>
            <span className="font-medium text-green-600">+{complianceImprovement}%</span>
          </div>
        </div>
      </div>
    </div>
  );
};
